<template>
  <div class="container">
    <div class="user">
      <router-link
        :to="{ name: 'UserOkr', params: { userId: alignedUser.id } }"
      >
        <AlignUser
          :user="alignedUser"
          :avatar-size="32"
          :text-size="16"
        />
      </router-link>
      <a-button
        shape="circle"
        @click="$emit('close')"
      >
        <template #icon>
          <CloseOutlined :style="{ color: '#9E9E9E'}" />
        </template>
      </a-button>
    </div>
    <div class="content">
      <a-skeleton
        v-if="loading"
        :active="true"
        :style="{padding: '16px 24px'}"
      />
      <div
        v-for="(objective, index) in objectives"
        :key="objective.id"
      >
        <div class="objective-container">
          <AlignedOkr
            :entity="entity"
            :okr-item="alignedUser.okrItems[index]"
            :can-edit="false"
            v-bind="$attrs"
            class="objective"
          />
          <div class="progress">
            <span>进度：</span>
            <span class="value">{{ objective.progress }} %</span>
          </div>
        </div>
        <performance
          v-if="!objective.performanceIsHide || user?.isMyManagementScope"
          :performance-objective="JSON.parse(objective.performanceObjective)"
        />
        <PerformanceReview
          v-if="lockStatus && user?.isMyManagementScope"
          :active-key="activeKey"
          :performance-objective-self-review="objective.performanceObjectiveSelfReview"
        />
        <ObjectiveReview
          :objective="objective"
          :can-edit="false"
          :reverse="true"
          :is-my-management-scope="user?.isMyManagementScope"
        />
      </div>
      <a-empty
        v-if="!loading && objectives.length === 0"
        :image="require('@/assets/images/empty-okr-list.png')"
        :image-style="{
          height: '30%'
        }"
        :description="$t('shared.noPermission')"
        class="empty-okr-list"
      />
    </div>
  </div>
</template>
<script>
import AlignUser from '@/components/AlignDialog/AlignUser'
import AlignedOkr from './../AlignedOkr'
import { getObjectives } from '@/graphql/okr'
import { computed, toRefs, ref } from 'vue'
import PerformanceReview from '@/components/ObjectiveCard/PerformanceReview'
import ObjectiveReview from '@/components/ObjectiveCard/ObjectiveReview/index.vue'
import Performance from './performance.vue'
import { useStore } from 'vuex'
import { getUser } from '@/graphql/user'
import { CloseOutlined } from '@ant-design/icons-vue'
export default {
  name: 'AlignedUsersForPerformanceModal',
  components: {
    AlignUser,
    AlignedOkr,
    PerformanceReview,
    ObjectiveReview,
    Performance,
    CloseOutlined
  },
  props: {
    alignedUser: {
      type: Object,
      required: true
    },
    entity: {
      type: Object,
      required: true
    }
  },
  emits: ['close'],
  setup (props) {
    const loading = ref(true)
    const store = useStore()
    const { alignedUser } = toRefs(props)
    const objectiveIds = computed(() => alignedUser.value.okrItems.map(item => item.objectiveId))
    const objectives = ref([])

    const user = ref(undefined)
    getUser(alignedUser.value.id)
      .then(data => {
        user.value = data
      })

    getObjectives(objectiveIds.value).then(res => {
      objectives.value = res
    }).finally(() => {
      loading.value = false
    })

    const lockStatus = computed(() => store.getters.lockStatus)

    const activeKey = ref(['performance-review'])

    return {
      objectives,
      activeKey,
      lockStatus,
      user,
      loading
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  background: #FFFFFF;
  box-shadow: 0 0 6px 0 rgba(39,52,125,0.08);
  border-radius: 12px;
  margin: 0 32px 24px 32px;
}

.user {
  padding: 24px 32px 16px 32px;
  background: #F8F9FF;
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: space-between;
}

.objective-container {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #f0f0f0;
}

.objective {
  padding: 16px 24px;
}

:deep(.ant-collapse-header) {
  padding: 12px 2px;
  border-top: 1px solid #f0f0f0;
}

:deep(.ant-collapse-item) {
  border: none;
}

.container {
  height: 100vh;
  overflow-y: overlay;
}

.progress {
  flex: 0 0 110px;
  text-align: right;
  padding: 16px 0;
  .value {
    padding-right: 16px;
  }
}

.empty-okr-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(100vh - 72px);
  background: #fff;
  box-shadow: 0 0 6px 0 rgba(39, 52, 125, 0.08);
  border-radius: 8px;
  margin: 0;
  :deep(.ant-space) {
    gap: 12px !important;
  }
}
</style>
